// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3e7Lr","author":"Table_author__1vnMg","authorImage":"Table_authorImage__2PR8b","unreadRow":"Table_unreadRow__1glWa"};